<template>
  <v-timeline-item
    color="error"
    large
    icon="far fa-question"
  >
    <v-card @click="$emit('clickItem')">
      <v-card-title class="body-2">{{item.start_time}}</v-card-title>
      <v-card-text>
        Unknown room <span v-if="item.average_rssi"> - prev room: ({{item.average_rssi}}/{{item.minimal_rssi || 'no minimal'}})</span><br>
        <template v-if="item.has_scan_results">
          <span class="font-weight-black">Profile:</span> {{ item.profile || 'undefined' }}<br>
          <span class="font-weight-black">Mode:</span> {{ item.mode || 'undefined' }}
        </template>
      </v-card-text>
    </v-card>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'UnknownRoom',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
